import React from "react";

const TextAreaInput = ({
  name,
  id,
  label,
  value,
  handleChange,
  placeholder,
  required,
  disabled,
  errorMessage,
  rows = 5,
  maxLength,
  cName,
  labelClassName,
  handleBlur,
}) => {
  // const [isFocused, setIsFocused] = useState(false);

  //const hasError = !!errorMessage[name];

  return (
    <div>
      {label && (
        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <div>
        <textarea
          name={name}
          id={id}
          className={`form-control mb-5px fs-5 ${cName} ${
            errorMessage && errorMessage?.[name]?.trim()?.length > 0
              ? "input-error"
              : ""
          }`}
          value={value}
          // onFocus={() => setIsFocused(true)}
          // onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          onChange={handleChange}
          // required={required}
          autoComplete="off"
          disabled={disabled}
          rows={rows}
          maxLength={maxLength}
          onBlur={handleBlur}
        />
        {errorMessage &&
          errorMessage[name] &&
          Object?.keys(errorMessage).length > 0 && (
            <div className={`text-danger fw-700 fs-6 mt-1 ${labelClassName}`}>
              {errorMessage && errorMessage[name] && errorMessage[name]}
            </div>
          )}
      </div>
    </div>
  );
};

export default TextAreaInput;
